import styled from "styled-components";

export const CardWrapper = styled("div")(({ width }) => {
    return {
        borderRadius: "1rem",
        padding: "var(--cardPadding)",
        width: width || "-webkit-fill-available",
        background: "#FFF",
        boxShadow: "0 8px 24px -4px rgba(26, 28, 28, 0.06)",
    }
})